import { UserResponse } from '@business/entities/account';
import { ClientProjectResponse, CompactClientProjectResponse, ProjectId } from '@business/entities/clientProject';
import { ProjectStepResponse } from '@business/entities/project';
import { Endpoint } from '../endpoint';

export function fetchClientProjects() {
  return Endpoint.get<CompactClientProjectResponse[]>(`@gc/shared-projects/client-projects`);
}

export function fetchProject(id: ProjectId, appId?: string) {
  return Endpoint.get<ClientProjectResponse>(`@gc/shared-projects/client-project/${id}${appId ? `?appId=${appId}` : ''}`);
}

export function toggleStep(stepId: number, tenantId?: string, completeAll?: boolean) {
  return Endpoint.post<ClientProjectResponse>(`@gc/shared-projects/client-toggle-step/${stepId}`, {
    data: { tenantId, completeAll: completeAll || false },
  });
}

export function fetchUsers(id: ProjectId) {
  return Endpoint.get<UserResponse[]>(`@gc/shared-projects/client-project-users/${id}`);
}

export function fetchStep(id: string) {
  return Endpoint.get<ProjectStepResponse>(`@gc/shared-projects/client-project-step/${id}`);
}
